import React, { useEffect } from 'react';
import './Membership.scss';
import { useDispatch, useSelector } from 'react-redux';
import { getOdMembership } from '../../../../actionCreators/membership';

const Membership = () => {
  const dispatch = useDispatch();
  const { result: membership, loading, error } = useSelector(state => state.membership);

  useEffect(() => {
    dispatch(getOdMembership());
  }, []);

  if (membership) {
    return (
      <div className="odMembership">
        <div className="odMembership__points">
          <div>Available Points</div>
          <div className="odMembership__value">{membership?.availableBalance}</div>
        </div>
        <div className="odMembership__badge">
          <img
            alt="Badge"
            className="odMembership__badgeIcon"
            src="https://static.lenskart.com/media/owndays/minified/regular-badge.webp"
          />
          <div className="odMembership__status">{membership?.currentMemberRank}</div>
        </div>
      </div>
    );
  }

  return null;
};

export default Membership;
